export default "__VITE_ASSET__BeL8Nibt__"